import styled from "@emotion/styled";

import {
  TopicContentListTopic,
  TopicContentListTopicOpinion,
} from "~/components/topic/topic-content-list";
import { TopicHeader } from "~/components/topic/topic-header";

export const Container = styled.section`
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: stretch;

  inline-size: 100%;
  padding-block-end: 60px;
`;

export const Header = styled(TopicHeader)``;

export const PrimaryTopicContainer = styled(TopicContentListTopic)`
  display: flex;
  flex-flow: column;
  justify-content: flex-start;
  align-items: stretch;
`;

export const SecondaryContainer = styled(TopicContentListTopicOpinion)`
  display: flex;
  flex-flow: column;
  justify-content: flex-start;
  align-items: stretch;
`;

export const Divider = styled.div`
  background: #e5e5e5;
`;

export const AdSlotWrapper = styled.div`
  box-sizing: content-box;
`;

export const Content = styled.div`
  display: grid;
  grid:
    "primary" 1fr
    / 100%;
  justify-content: center;

  inline-size: 100%;

  ${PrimaryTopicContainer} {
    grid-area: primary;
  }

  ${SecondaryContainer} {
    grid-area: secondary;

    display: none;
  }

  ${AdSlotWrapper} {
    grid-area: ad-slot;

    display: none;
  }

  ${Divider} {
    grid-area: divider;

    display: none;
  }

  ${props => props.theme.breakpoints.up("tablet")} {
    grid:
      "primary divider secondary" 1fr
      / minmax(0, 1fr) min-content 210px;

    margin-block-start: 32px;

    ${SecondaryContainer} {
      display: block;
    }

    ${Divider} {
      display: block;

      inline-size: 0;
      margin-inline: 10px;
    }

    ${SecondaryContainer}:not(:empty) ~ ${Divider} {
      inline-size: 1px;
    }
  }

  ${props => props.theme.breakpoints.up("desktop")} {
    grid:
      "primary divider secondary" 1fr
      / minmax(0, 1fr) min-content 300px;

    ${Divider} {
      margin-inline: 20px;
    }
  }

  ${props => props.theme.breakpoints.up("mediumDesktop")} {
    grid:
      "primary divider ad-slot" min-content
      "primary divider secondary" 1fr
      / minmax(0, 1fr) min-content 300px;
    align-self: center;

    max-inline-size: 1170px;

    ${AdSlotWrapper} {
      display: block;

      inline-size: 300px;
      block-size: 250px;
      padding-block-end: 36px;
    }
  }
`;
